import classnames from "classnames";
import parse, { domToReact } from "html-react-parser";
import React, { useEffect, useState } from "react";

// Components
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";
import ContactUsChatBanner from "../contact-us-chat-banner/ContactUsChatBanner";

// Util
import { getSolutionContactDetails } from "../../utils/data/getContactDetails";

// Styles
import styles from "./contact-us-product-stock-solution.module.scss";

const getActiveContent = fields =>
  fields.find(
    ({ name, startDate, expirationDate }) =>
      name === "content" &&
      ((!startDate && !expirationDate) || new Date(startDate) < new Date() || new Date(expirationDate) > new Date()),
  ).content;

function ContactUsProductStockOtherSolution({
  solution: { id, title, fields, buttonType, hierarchyPosition },
  className,
  contactMethods = {},
}) {
  const [isBannerSupported, setIsBannerSupported] = useState(false);

  useEffect(() => {
    const getContactDetails = async () => {
      const contactDetails = await getSolutionContactDetails(
        `${hierarchyPosition[0]} | ${hierarchyPosition[1]} | ${hierarchyPosition[2]}`,
      );
      setIsBannerSupported(contactDetails.chat.partnersBanner);
    };

    getContactDetails();
  }, []);

  const locationOnPage = hierarchyPosition.join(" | ");

  return (
    <article className={classnames(styles.productStockSolution, className)} data-solution-id={id}>
      <h2 className={styles.productStockSolution__top}>Did you know...</h2>
      <div className={styles.productStockSolution__inner} data-test="solution-inner">
        {title && <h2 data-test="solution-name">{title}</h2>}
        <div className={styles.productStockSolution__content}>
          {parse(getActiveContent(fields), {
            replace: ({ type, name: tagName, attribs: { ...nonStyleAttribs } = {}, children }) =>
              type === "tag" && nonStyleAttribs && React.createElement(tagName, nonStyleAttribs, domToReact(children)),
          })}
        </div>
        {isBannerSupported && (
          <ContactUsChatBanner
            location={locationOnPage}
            channel={fields.find(({ name }) => ["chat"].includes(name)).content}
          />
        )}
        <ContactDetailsBox
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          buttonType={buttonType}
          solutionId={id}
          className={styles["productStockSolution__contact-details"]}
          location={locationOnPage}
          contactMethods={contactMethods}
          title={"We’re here to help"}
          viewContactDetails
          showGreyBackground
        />
      </div>
    </article>
  );
}

export default ContactUsProductStockOtherSolution;
